import { afterAttack, afterEvent, defineGameCard, drawCards, heatsUp, oncePerInstance, } from '../authoring/index.js';
export const OverclockedScoutCard = defineGameCard({
    id: 'overclocked_scout',
    gameplay: {
        type: 'UNIT', cost: 1,
        baseStats: { attack: 1, health: 2 }, keywords: ['RUSH'],
    },
    presentation: {
        name: 'Разогнанный разведчик',
        description: 'Натиск. Греется. В первый раз, когда полностью охлаждается после атаки, возьмите 2 карты.',
        glyph: {
            colors: ['#10213A', '#C27730', '#404854', '#61727D', '#31353E'],
            rows: [
                '............1111....',
                '22.........133441...',
                '..22.11111.133441...',
                '....1444441553341...',
                '...13115335553541...',
                '..131..1534555351.11',
                '.131....12245521.151',
                '.111.22.13222421..51',
                '........134422531151',
                '.......155444115331.',
                '22222.1153511..111..',
                '......13441.........',
                '......1334411.......',
                '..2...15533541......',
                '22...1551.1331......',
                '....1551.1311.......',
                '...1511.131.........',
                '..151..151..........',
                '.111...11...........',
                '.1......11..........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterAttack(oncePerInstance({
            abilityId: 'first_attack_heat',
            trigger: 'onAttackResolved',
            when: () => true,
            run: () => undefined,
        })),
        heatsUp(),
        afterEvent({
            abilityId: 'first_cooling_draw',
            event: 'HeatChanged',
            frequency: 'first_per_instance',
            when: (ctx, event) => ctx.self !== undefined
                && event.instanceId === ctx.self.id
                && event.previous > 0
                && event.current === 0
                && event.reason === 'cooled'
                && ctx.self.vars['@cards/ability/overclocked_scout/first_attack_heat/used'] === true,
            run: drawCards(2),
        }),
    ],
    ui: {
        mechanics: ['rush', 'heats_up', 'heat'],
        publicVars: {
            attackedOnce: {
                key: '@cards/ability/overclocked_scout/first_attack_heat/used',
                kind: 'boolean',
            },
            coolingRewardDrawn: {
                key: '@cards/ability/overclocked_scout/first_cooling_draw/used',
                kind: 'boolean',
            },
        },
        statusProviders: [(context) => context.card.facts.attackedOnce === true
                ? [{
                        id: 'first-cooling-draw',
                        symbol: context.card.facts.coolingRewardDrawn === true ? '✓' : '⚙',
                        label: context.card.facts.coolingRewardDrawn === true
                            ? 'Добор получен'
                            : 'Ждёт охлаждения',
                        description: context.card.facts.coolingRewardDrawn === true
                            ? 'Карта уже взяла 2 карты за первое полное охлаждение.'
                            : 'После первой атаки карта возьмёт 2 карты, когда полностью охладится.',
                        tone: 'neutral',
                    }]
                : []],
    },
});
//# sourceMappingURL=overclocked-scout.js.map